import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const DepreciationActionsEdit = ({
  depreciation,
  company,
  subcompany,
  t,
  handleClick = () => {},
}) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(company.id, subcompany.id, `depreciations/${depreciation.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(DepreciationActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/actions/DepreciationsActionsEdit.js